/**
 * ErrorState — renders S-5 error state with retry button.
 *
 * Message: "Couldn't load files. Please try again."
 * Button: "Retry" — calls onRetry callback.
 */

import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface ErrorStateProps {
  message?: string;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message = "Couldn\u2019t load files. Please try again.",
  onRetry,
}) => (
  <Box
    data-testid="error-state"
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "200px",
      bgcolor: "#fafbfb",
      borderRadius: "8px",
      border: "1px dashed #dae0e2",
      p: 4,
      gap: 2,
    }}
  >
    <Typography
      data-testid="error-message"
      sx={{ color: "#898989", textAlign: "center" }}
    >
      {message}
    </Typography>
    <Button
      data-testid="retry-button"
      variant="contained"
      onClick={onRetry}
      sx={{ textTransform: "none" }}
    >
      Retry
    </Button>
  </Box>
);
